<template>
  <div class="alert-warning__plan">
    <div class="alert-warning__title">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
      </svg>
      IMPORTANTE
    </div>
    <p style="margin: 0px" v-if="plan.pagoRecurrente">
      Tu plan <span class="alert-warning__highlight light">{{ plan.nombrePlan }}</span>
      iniciará el día <span class="alert-warning__highlight light">{{ fechaHoy | formatoFechaLarga }}</span>,
      su próxima <span class="alert-warning__highlight">renovación automática</span> será el
      <span class="alert-warning__highlight">{{ plan.vigenciaFin | formatoFechaLarga }}</span>
    </p>
    <p style="margin: 0px" v-else>
      Tu plan <span class="alert-warning__highlight light">{{ plan.nombrePlan }}</span>
      iniciará el día <span class="alert-warning__highlight light">{{ fechaHoy | formatoFechaLarga }}</span>
      y <span class="alert-warning__highlight"> finalizará </span> el <span class="alert-warning__highlight">{{ plan.vigenciaFin | formatoFechaLarga }}</span>
    </p>
  </div>
</template>

<script>
/*
* En la informacion que llega en el prop "plan" ya trae la información con respecto al tipoVigenciaSeleccionada incluyendo
* la fechaVigenciaFin correspondiente si es vigenciaPolizaPaciente o vigenciaPlan
* */
export default {
  name: 'AlertaVigenciaPlan',
  props: {
    plan: {
      type: Object,
      required: true
    },
  },
  computed: {
    fechaHoy() {
      return this.$moment().format('YYYY-MM-DD');
    },
  }
}
</script>

<style>
.alert-warning__plan {
  background-color: #FDFAF1;
  border-left: 4px solid #F5A623;
  color: #5C5952;
  padding: 12px 16px;
  border-radius: 4px;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.5;
  margin: 12px 0;
}

.alert-warning__title {
  color: #E89548;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 13px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.alert-warning__highlight {
  color: #1464A5;
  font-weight: bold;
}

.alert-warning__highlight.light {
  color: var(--blue);
  font-weight: bold;
}

</style>
